export const SESSIONS_TOOLTIP =
  'A session captures a user’s browsing activity over time. It includes at least one page view, is formed from multiple events, ends after 30 minutes of inactivity, and must be at least 5 seconds long.';
